import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslocoDirective } from "@jsverse/transloco";
import { ButtonModule } from "primeng/button";
import { DatePickerModule } from "primeng/datepicker";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import {
  DeactivateExtraServiceDialogConfig,
  DeactivateExtraServiceDialogResult,
} from "./deactivate-extra-service-dialog.types";

@Component({
  templateUrl: "./deactivate-extra-service.dialog.html",
  imports: [FormsModule, DatePickerModule, ButtonModule, TranslocoDirective],
})
export class DeactivateExtraServiceDialog {
  public readonly earliestTerminationDate: Date;
  public terminationDate: Date;

  constructor(
    private readonly config: DynamicDialogConfig<DeactivateExtraServiceDialogConfig>,
    public readonly ref: DynamicDialogRef<DeactivateExtraServiceDialogResult>,
  ) {
    if (!this.config.data) {
      throw new Error("Deactivate extra service dialog configuration not found");
    }

    this.earliestTerminationDate = this.config.data.earliestTerminationDate;
    this.terminationDate = this.config.data.earliestTerminationDate;
  }

  public cancel(): void {
    this.ref.close();
  }

  public confirm(): void {
    // The backend validates against end-of-day in UTC, so submit the chosen calendar day as end-of-day UTC.
    const selected = new Date(this.terminationDate);
    const terminationDate = new Date(
      Date.UTC(selected.getFullYear(), selected.getMonth(), selected.getDate(), 23, 59, 59, 999),
    );
    this.ref.close({ terminationDate });
  }
}
